import { trackEvent } from '@/lib/ga'
import { GA_EVENT } from '@/lib/ga/constants/gaEvent'

/**
 * Handles popular section tracking
 * This will be re-used for all 3 popular section as well as the "Browse All" links
 */
export const handlePopularCategoryTracking = (categoryId: number) => {
  trackEvent({ action: GA_EVENT.CategorySelected, label: `catId=${categoryId};btn=popular` })
}
